import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initTheme } from "./audit/useTheme";
import { AuditSearchProvider } from "./audit/AuditSearchContext";
import UpdateBanner from "./components/UpdateBanner";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setToken } from "./audit/authState";  // 설계 v7 §4-3 래퍼
import { consumeSsoFragment } from "./audit/ssoHandoff";

// 크로스탭 재사용용 창 이름 — docuai2 등에서 window.open(url,"loginhsHub")로 이 탭을 재사용.
try {
  window.name = "loginhsHub";
} catch (_e) {
  /* noop */
}

// ── SSO: 다른 제품(docuai2·LCS V2)에서 URL 프래그먼트 #sso=<jwt> 로 넘어온 토큰 수신 ──
//   JWT_SECRET 공유라 loginhs-spring 에서 그대로 유효 → 재로그인 없이 자동 로그인.
//   프래그먼트(#)는 서버로 전송/로그되지 않아 안전. render 전에 실행해 App 이 바로 인식.
//   72차: 토큰 안의 신원(sub·groupId·name)까지 저장한다 — 이 브라우저로 처음 오는 사람은
//   groupCode·userId 가 없어 토큰이 있어도 화면이 로그아웃으로 보였다(App 은 세 값을 다 본다).
consumeSsoFragment({ setToken });

// 페이지 load 시 localStorage 의 배경 테마 적용 — FOUC 방지 (render 전).
initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // 🔧 StrictMode 제거: @react-pdf-viewer 3.12.0이 React 19 StrictMode의
  // 이중 effect 실행(mount→unmount→remount)과 호환되지 않아 'destroy' 에러 발생
  // StrictMode는 개발 모드 전용이며, 프로덕션 빌드에는 영향 없음
  <>
    <AuditSearchProvider>
      <App />
    </AuditSearchProvider>
    <UpdateBanner />
  </>,
);

// PWA 자동 업데이트 — 새 버전 감지 시 상단 [업데이트] 배너(malso 방식).
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.__swRegistration = registration;
    window.dispatchEvent(new CustomEvent("sw-update-available"));
  },
});
